<div [formGroup]="addEditComponentForm" style="margin: 16px;">

  <app-component-sub-html-inner-template [form]="addEditComponentForm" [componentSubtypes]="componentSubtypes"
    [manufacturingCountries]="manufacturingCountries" [canEditForm]="canEditForm" [isDecoration]="isDecoration"
    [isTracked]="isTracked" [isMainBody]="isMainBody" [isInlay]="isInlay" [componentTypeSelectionLabel]="componentTypeSelectionLabel"
    [removabilityConditions]="removabilityConditions" (adhesivesOptionChanged)="onAdhesivesOptionChange($event)"
    (componentSubtypeChanged)="onComponentTypeChange($event)"
    [(relevantAnalysisTypes)]="relevantAnalysisTypes">
  </app-component-sub-html-inner-template>

  <mat-card>
    <mat-card-content class="table-container-wide">
      <app-multi-material-table [parentCompositeMaterial]="compositeMaterial"
        [allMaterialFunctions]="allMaterialFunctions" [allColors]="allColors" [allManifestations]="allManifestations"
        [callerId]="callerId" [manufacturingCountry]="selectedManufacturingCountry"
        [packagingUnitTypeId]="packagingUnitTypeId" [canEditForm]="canEditForm" [isFirstOpen]="isNew"
        (totalWeightChanged)="totalWeightChanged($event, addEditComponentForm)" (materialChanged)="materialChanged($event)"
        [(relevantAnalysisTypes)]="relevantAnalysisTypes" [isPartOfTrackedComponent]="addEditComponentForm.controls.hasInternalTracking.value"
        [isDataExchangeSubRequest]="isDataExchangeSubRequest" [trackedComponentMultiMaterial]="addEditComponentForm.controls.multiMaterial.value">
      </app-multi-material-table>
    </mat-card-content>
  </mat-card>
</div>
